export default "__VITE_PUBLIC_ASSET__fa30e89f__"